export default __webpack_public_path__ + "static/media/firststeplg.441af315.png";